import React from "react";
import "./CanvasDebugger.scss";
import { Tabs, Tab, TabPanel } from "../../shared/components";
import Metadata from "./Metadata";
import Templates from "./Templates";
import FrameData from "./FrameData";
import ParameterValues from "./ParameterValues";
import Traces from "./Traces";
import VsCode from "./VsCode";
import Diagnostics from "./Diagnostics";
import Profiling from "./Profiling";
import Datasources from "./Datasources";
import { useAppSelector } from "../../store";
import { usePopoutWindowContext } from "../../shared/components/PopoutWindow";

function CanvasDebugger() {
    const hasSlide = useAppSelector(state => !!state.storyline.currentParagraph);
    const [selectedTabIndex, setSelectedTabIndex] = React.useState(0);
    // The editor controls do not enjoy being used in a semi-headless state, so we add a small artificial delay between initial pop-up window render
    // and the time the editor is shown...
    const [loading, setLoading] = React.useState(true);
    const popoutWindowContext = usePopoutWindowContext();

    React.useEffect(() => {
        setTimeout(() => {
            setLoading(false);
            // After all the controls are rendered, pull the new dynamic styles from the parent window...
            setTimeout(() => popoutWindowContext.pullStylesFromParentWindow(), 500);
        }, 100);
    }, []);

    const handleTabChange = React.useCallback((_event: React.ChangeEvent<{}>, newSelectedIndex: number) => {
        setSelectedTabIndex(newSelectedIndex);
    }, [setSelectedTabIndex]);

    if (!hasSlide) return null;

    return (
        <div className="canvas-debugger">
            {
                loading ?
                    <div className="screen-centered">Initializing...</div> :
                    <>
                        <Tabs
                            variant="scrollable"
                            scrollButtons="auto"
                            allowScrollButtonsMobile={true}
                            value={selectedTabIndex}
                            onChange={handleTabChange}
                        >
                            <Tab label="Metadata" />
                            <Tab label="Templates" />
                            <Tab label="Frame Data" />
                            <Tab label="Parameter Values" />
                            <Tab label="Datasources" />
                            <Tab label="Event Log" />
                            <Tab label="VS Code" />
                            <Tab label="Problems" />
                            <Tab label="Profiling" />
                        </Tabs>

                        <TabPanel key="tab-0" selectedValue={selectedTabIndex} value={0}>
                            <Metadata />
                        </TabPanel>

                        <TabPanel key="tab-1" selectedValue={selectedTabIndex} value={1}>
                            <Templates />
                        </TabPanel>

                        <TabPanel key="tab-2" selectedValue={selectedTabIndex} value={2}>
                            <FrameData />
                        </TabPanel>

                        <TabPanel key="tab-3" selectedValue={selectedTabIndex} value={3}>
                            <ParameterValues />
                        </TabPanel>

                        <TabPanel key="tab-4" selectedValue={selectedTabIndex} value={4}>
                            <Datasources />
                        </TabPanel>

                        <TabPanel key="tab-5" selectedValue={selectedTabIndex} value={5}>
                            <Traces />
                        </TabPanel>

                        <TabPanel key="tab-6" selectedValue={selectedTabIndex} value={6}>
                            <VsCode />
                        </TabPanel>

                        <TabPanel key="tab-7" selectedValue={selectedTabIndex} value={7}>
                            <Diagnostics />
                        </TabPanel>

                        <TabPanel key="tab-8" selectedValue={selectedTabIndex} value={8}>
                            <Profiling />
                        </TabPanel>
                    </>
            }
        </div>
    );
}

export default CanvasDebugger;
